// Prepare the complete selection before changing the draft, so an invalid item
// or the device limit never leaves a partly imported playlist.
export function preparePlaylistAddition(items, assetIds, resolveAsset, createItem) {
  const selected=[...new Set(assetIds)];
  if(items.length+selected.length>16)throw new Error("A Pirdy playlist supports up to 16 items.");
  return selected.map(id=>{
    const asset=resolveAsset(id);
    if(!asset)throw new Error("Selected content is no longer available. Select it again.");
    return createItem(asset);
  });
}
